import type { DocFormat, IssueCategory, Report, Severity } from '#lib/types';

export const CATEGORIES = ['statistics','citations','structure','language','provenance','access'] as const;
export const SEVERITIES = ['critical','warning','info','ok'] as const;
export interface AnalysisStatistics {
 schemaVersion: 1;
 analysisId: string;
 mode: 'preview' | 'full';
 source:'file'|'paste'|'demo';
 engineVersion: '1.0';
 fileType: DocFormat;
 fileSize: number;
 pages: number;
 chars: number;
 durationMs: number;
 score: number;
 grade: Report['scores']['grade'];
 counts: Record<Severity,number>;
 categories: Array<{category:IssueCategory;score:number;issueCount:number;criticalCount:number;checked:boolean}>;
 issueCodes: Record<string,number>;
}

// This projection deliberately never copies a name, title, quote, reference or document text.
export function projectStatistics(report:Report, meta:{analysisId:string;mode:'preview'|'full';source:'file'|'paste'|'demo';fileSize:number;durationMs:number}):AnalysisStatistics {
 const issueCodes:Record<string,number>={};
 for(const issue of report.issues) issueCodes[issue.code]=(issueCodes[issue.code]??0)+1;
 return {
  schemaVersion:1, analysisId:meta.analysisId, mode:meta.mode, source:meta.source, engineVersion:report.version,
  fileType:report.document.format, fileSize:meta.fileSize, pages:report.document.pages,
  chars:report.document.chars, durationMs:Math.max(0,Math.round(meta.durationMs)),
  score:report.scores.overall, grade:report.scores.grade,
  counts:{critical:report.counts.critical,warning:report.counts.warning,info:report.counts.info,ok:report.counts.ok},
  categories:report.scores.categories.map(c=>({category:c.category,score:c.score,issueCount:c.issueCount,criticalCount:c.criticalCount,checked:c.checked})),
  issueCodes
 };
}
